<template>
    <div>
        <v-card style="height:200px;" class="pa-2">
            <!-- <v-card-text > -->
                <div style="max-height:180px; overflow-y:scroll;">
                    <SickLeaveCountdown />
                    <JoinBriefing />
                    <LeaveCarryForward />
                    <AssetHandoverAlert />

                    <!-- <AttendanceSpecialLeave /> -->

                    <template v-for="(message, mi) in messages" >
                        <v-alert
                            :key="mi"
                            dense text
                            :type="message.type || 'info'"
                            :color="message.color"
                            :icon="message.icon || 'mdi-information-outline'"
                            class="mb-2"
                        >
                            <span v-html="message.text"></span>
                        </v-alert>
                    </template>
                </div>
            <!-- </v-card-text> -->
        </v-card>
    </div>
</template>

<script>
import JoinBriefing from './JoinBriefing.vue'
import SickLeaveCountdown from './SickLeaveCountdown.vue'
import LeaveCarryForward from './LeaveCarryForward.vue'
import AssetHandoverAlert from '../office-assets/AssetHandoverAlert.vue'

import AttendanceSpecialLeave from './AttendanceSpecialLeave.vue'

export default {
    components: {JoinBriefing, SickLeaveCountdown, LeaveCarryForward, AssetHandoverAlert, AttendanceSpecialLeave},
    data: () => ({
        messages: [],
    }),
    methods: {
        getMOTD(){
            this.$axios.get(`/api/dashboard/motd`).then(res => {
                this.messages = res.data
            })
        },
    },
    mounted() {
        this.getMOTD()
    },
}
</script>

<style>

</style>